import React from 'react';
import Head from 'next/head';
import Image from 'next/image';
import Container from 'react-bootstrap/Container';
import SimpleFooter from '@components/SimpleFooter/SimpleFooter';
import templateDataService from '@/services/template-data-service';
import styles from './RegisterLayout.module.scss';

interface IRegisterLayout {
  children?: React.ReactNode;
  theme?: AppTheme;
}

export const RegisterLayout = ({ children }: IRegisterLayout) => {
  const templateData = templateDataService.getTemplateData();

  return (
    <>
      <Head>
        <title>Mijn Carel Lurvink</title>
      </Head>
      <header className={styles.header}>
        <Image src={templateData.sector.logo} alt="Carel Lurvink logo" width={60} height={60} className={styles.logo} priority />
      </header>
      <main className="my-3">
        <Container>{children}</Container>
      </main>
      <SimpleFooter />
    </>
  );
};
